module.exports = __webpack_public_path__ + "img/eto_luna_winter.64be41cd.png";